// removed by extract-text-webpack-plugin
module.exports = {"component":"_1lmFpBMExz5yiLS5WY8Rvu","loginPic":"_2vclWFi32QBHTufG772LW9","loginMes":"_6-bVMSNgFSHBthsBDsT9I","loginH1":"_2I1mqZmpMEAcUxBy0NCCNw","bottomContainer":"_1_tRVs3NKQVRgXeXMT02JE","btn":"_1nlR-sIyFB6oFWWKyPH_Iv","imgBtn":"_1mVN58gMC4CwRHDKGRjB_","helpDiv":"_3LSZ8zbjlR5sSbNXza3SgR","mt15":"_2i-z_kNqMIm-pFb8bE1oAH","helpbtn":"fFKf9z7Xgo-9m7mJTpdfy"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/BVLogin/BVLogin.scss
 ** module id = 1051
 ** module chunks = 0
 **/